import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function StudentCtcValidator(): ValidatorFn {
	return (control: AbstractControl): ValidationErrors | null => {

		const value = control.value?.toString().trim();

		if (!value) {
			return null;
		}

		if (!/^\d+(\.\d{1,2})?$/.test(value)) {
			return { invalidCtc: true };
		}

		const amount = parseFloat(value);

		if (amount < 0 || amount > 1000) {
			return { ctcOutOfRange: true };
		}

		return null;
	};
}